import * as React from "react";
import AbductorInfoMatch from "./AbductorInfoMatch";
import BiometricaDetail from "../../BoundingBox/Biometrica/BiometricaDetail";
import { IMatch } from "src/share/types/match";

export interface IBiometricaMatchesProps {
  matchInfo: IMatch;
}

const BiometricaMatches = ({ matchInfo }: IBiometricaMatchesProps) =>
  matchInfo && (
    <>
      <AbductorInfoMatch matchInfo={matchInfo} />
      <BiometricaDetail matchInfo={matchInfo} />
    </>
  );

export default React.memo(BiometricaMatches);



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/components/BiometricaMatches.tsx